import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'
import { getNombreArchivoCartaReservaQueryOData } from '@/modules/ReservasTemp/constants/queriesStringOData'

export interface CartaReservaQuery {
  ReservaCentralizadaId: number
  ConfiguracionReserva: {
    ConfiguracionReservaId: number
    CartaNuevaReserva: string
    CartaModificacionReserva: string
    CartaCancelacionReserva: string
    CartaRoomingListReserva: string
  }
}

export const cartaReservaApi = createApi({
  reducerPath: 'cartaReservaApi',
  baseQuery,
  endpoints: (builder) => ({
    getCarta: builder.query<
      GenericResponseOData<CartaReservaQuery[]>,
      { id: number; type: string }
    >({
      query: ({ id, type }) => ({
        url: `/ReservasCentralizadas?${getNombreArchivoCartaReservaQueryOData.replace('{ID}', id.toString()).replace('{TYPE}', type)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetCartaQuery } = cartaReservaApi
